import React from "react";
import {COMMON_DATA_LOADED} from "./CommonReducer";

const SET_USER_LOGIN_EXPIRED = "locale/global/SET_USER_LOGIN_EXPIRED";
const SHOW_MODAL = 'locale/global/SHOW_MODAL';
const HIDE_MODAL = 'locale/global/HIDE_MODAL';
const HIDE_ALL_MODALS = 'locale/global/HIDE_ALL_MODALS';
const TOGGLE_NOTIFICATION_MODAL = "locale/global/TOGGLE_NOTIFICATION_MODAL";
const CLEAR_NOTIFICATIONS = "locale/global/CLEAR_NOTIFICATIONS";
const ADD_LOADING_STATE = "locale/global/ADD_LOADING_URL";
const REMOVE_LOADING_STATE = "locale/global/REMOVE_LOADING_URL";

export const setUserLoginExpired = () => ({
    type: SET_USER_LOGIN_EXPIRED,
});

/**
 *
 * @param modalKey                 Name / id of the modal to be opened
 * @param modalState            Any data needed by the modal. Defaults to 'true'
 * @returns {{modalState, type: string, modal}}
 */
export const showModal = (modalKey, modalState = true) => ({
    type: SHOW_MODAL,
    payload: {
        modalKey,
        modalState
    }
});

export const hideModal = (modalKey) => ({
    type: HIDE_MODAL,
    payload: {modalKey}
})

export const hideAllModals = () => ({
    type: HIDE_ALL_MODALS,
})

export const toggleNotificationModal = (status) => ({
    type: TOGGLE_NOTIFICATION_MODAL,
    status
});

export const clearNotifications = () => ({
    type: CLEAR_NOTIFICATIONS
});

/**
 * Add a URL to the loading state
 *
 * @param {string} url - URL to add to the loading state
 * @returns {{type: string, url: string}}
 */
export const addLoadingUrl = (url) => ({
    type: ADD_LOADING_STATE,
    url
});

/**
 * Remove a URL from the loading state
 *
 * @param {string} url - URL to remove from the loading state
 * @returns {{type: string, url}}
 */
export const removeLoadingUrl = (url) => ({
    type: REMOVE_LOADING_STATE,
    url
});

export const initialState = {
    openModals: {},
    loadingState: [],
    userLoginExpired: false,
    notificationModalStatus: false,

    // The following values will be preloaded from the values injected into
    // the template on the initial load. They're defined in GlobalDataResource.php
    currentUser: {},
    unreadNotificationCount: 0,
    siteTitle: '',
    siteType: '',
    siteTypeLabel: '',
    siteTypeLabelPlural: '',
    onboarding: '',
};

export const globalReducer = (state = initialState, action) => {
    // Intercept the common data loaded action within this reducer
    // so we can potentially store some data in the global store.
    // We want to ignore the admin global data though...
    if (action.type
        && action.type.endsWith(COMMON_DATA_LOADED)
        && !action.type.startsWith('admin')
    ) {
        let newState = {
            ...state,
            ...action.payload.global
        }

        if (action.payload.global) {
            newState.siteType = action.payload.global.siteType;
            newState.siteTypeLabel = action.payload.global.siteTypeLabel;
            newState.siteTypeLabelPlural = action.payload.global.siteTypeLabelPlural;
        }

        return newState;
    }

    switch (action.type) {
        case SET_USER_LOGIN_EXPIRED: {
            return {
                ...state,
                userLoginExpired: true
            }
        }

        case SHOW_MODAL:
            return {
                ...state,
                openModals: {
                    ...state.openModals,
                    [action.payload.modalKey]: action.payload.modalState ?? true
                }
            }

        case HIDE_MODAL:
            let updatedOpenModals = {
                ...state.openModals,
            };

            delete updatedOpenModals[action.payload.modalKey];
            return {
                ...state,
                openModals: updatedOpenModals,
            }

        case HIDE_ALL_MODALS:
            return { ...state, openModals: {} }

        case TOGGLE_NOTIFICATION_MODAL: {
            return {
                ...state,
                notificationModalStatus: action.status
            }
        }

        case CLEAR_NOTIFICATIONS: {
            return { ...state, unreadNotificationCount: 0 };
        }

        case ADD_LOADING_STATE: {
            return {
                ...state,
                loadingState: [...state.loadingState, action.url]
            }
        }

        case REMOVE_LOADING_STATE: {
            return {
                ...state,
                loadingState: state.loadingState.filter(url => url !== action.url)
            }
        }

        default:
            return state;
    }
};

